function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Button/Back");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Player/03---1820",
  transform: "translate(-39.000000, -394.000000)"
}, React.createElement("g", {
  id: 2,
  transform: "translate(0.000000, 140.000000)"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("g", {
  id: "Chapters",
  transform: "translate(24.000000, 176.000000)"
}, React.createElement("g", {
  id: 6,
  transform: "translate(12.000000, 76.000000)"
}, React.createElement("g", {
  id: "Button/Back"
}, React.createElement("g", {
  id: "Icons/Pause"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("g", {
  id: "Background"
}), React.createElement("path", {
  d: "M4,2 C4.55228475,2 5,2.44771525 5,3 L5,13 C5,13.5522847 4.55228475,14 4,14 C3.44771525,14 3,13.5522847 3,13 L3,3 C3,2.44771525 3.44771525,2 4,2 Z M12,2 C12.5522847,2 13,2.44771525 13,3 L13,13 C13,13.5522847 12.5522847,14 12,14 C11.4477153,14 11,13.5522847 11,13 L11,3 C11,2.44771525 11.4477153,2 12,2 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  mask: "url(#mask-2)"
})))))))));

var SvgPause = function SvgPause(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "10px",
    height: "12px",
    viewBox: "0 0 10 12",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPause, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pause.d39b6e58.svg";
export { ForwardRef as ReactComponent };